import { addNotificationAction } from 'store/notifications/notificationsActions';
import { useDispatch } from 'react-redux';

const useNotifications = () => {
  const dispatch = useDispatch();

  const notifySuccess = message => dispatch(addNotificationAction({ message, variant: 'success' }));

  const notifyError = message => dispatch(addNotificationAction({ message, variant: 'error' }));

  return {
    notifySuccess,
    notifyError,
  };
};

export { useNotifications };
